import request from '@core/services/request';

export const videosAPI = {
	saveVideoDetails: (videoInfo: any) => request.post(`/Videos/SaveVideoDetails`, videoInfo),
	getDealVideos: (fimenuId: any) => request.get(`/Videos/GetDealVideos?fimenuId=${fimenuId}`),
};
